/* ================================================== */
/* MENU → mobile
/* ================================================== */

$(document).ready(function() {

	$('.btn-menu-mobile').click(function(e) {
		e.preventDefault();
		$('#menu-mobile').toggleClass('open');
		if (!$('#menu-mobile .scrolling').is('.mCustomScrollbar')) {
			$('#menu-mobile .scrolling').mCustomScrollbar({
				axis         : 'y',
				scrollInertia: 300
			});
		}
	});

});